import PropTypes from 'prop-types';

const NewInterface = {
  id: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  author: PropTypes.shape({
    user: PropTypes.shape({}),
    association: PropTypes.shape({})
  }),
  creationDate: PropTypes.string,
  mediaType: PropTypes.oneOf(['IMAGE', 'VIDEO', 'GALLERY']),
  nameFile: PropTypes.string
};

export const NewModel = PropTypes.shape({
  ...NewInterface
});

export const NewModelDetail = PropTypes.shape({
  ...NewInterface,
  tags: PropTypes.arrayOf(PropTypes.string),
  baseContentType: PropTypes.oneOf(['NEWS']),
  comments: PropTypes.bool,
  body: PropTypes.string
});

export const CommentsModel = PropTypes.shape({
  date: PropTypes.string,
  text: PropTypes.string,
  userId: PropTypes.number,
  userName: PropTypes.string,
  replies: PropTypes.arrayOf(PropTypes.shape({})),
  numReplies: PropTypes.number
});
